import { Suspense, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'
import { BottomNav } from './BottomNav'
import { QuickActionsModal } from '@/features/auth/QuickActionsModal'

export function AdminLayout() {
  const [collapsed, setCollapsed] = useState(false)

  return (
    <div className="flex min-h-screen bg-background">
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} />

      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="flex-1 p-4 pb-20 md:p-6 md:pb-6">
          <Suspense fallback={<PageLoading />}>
            <Outlet />
          </Suspense>
        </main>
      </div>

      <BottomNav />
      <QuickActionsModal />
    </div>
  )
}

function PageLoading() {
  return (
    <div className="flex min-h-40 items-center justify-center text-sm text-muted-foreground">
      Cargando…
    </div>
  )
}
